export function Shaders () {
return {
  shdSFlo1:`

               vec3 hash( vec3 p ) // replace this by something better
{
p = vec3( dot(p,vec3(127.1,311.7, 74.7)),
dot(p,vec3(269.5,183.3,246.1)),
dot(p,vec3(113.5,271.9,124.6)));
return -1.0 + 2.0*fract(sin(p)*43758.5453123);
}
float noise(vec3 p )
{
    vec3 i = floor( p );
    vec3 f = fract( p );
vec3 u = f*f*(3.0-2.0*f);
 return mix( mix( mix( dot( hash( i + vec3(0.0,0.0,0.0) ),
                           f - vec3(0.0,0.0,0.0) ),
  dot( hash( i + vec3(1.0,0.0,0.0) ), f - vec3(1.0,0.0,0.0) ), u.x),
  mix( dot( hash( i + vec3(0.0,1.0,0.0) ), f - vec3(0.0,1.0,0.0) ),
 dot( hash( i + vec3(1.0,1.0,0.0) ),
     f - vec3(1.0,1.0,0.0) ), u.x), u.y),
 mix( mix( dot( hash( i + vec3(0.0,0.0,1.0) ), f - vec3(0.0,0.0,1.0) ),
 dot( hash( i + vec3(1.0,0.0,1.0) ), f - vec3(1.0,0.0,1.0) ), u.x),
mix( dot( hash( i + vec3(0.0,1.0,1.0) ), f - vec3(0.0,1.0,1.0) ),
dot( hash( i + vec3(1.0,1.0,1.0) ),
    f - vec3(1.0,1.0,1.0) ), u.x), u.y), u.z );
}
float simpleNoise(vec2 uv,float freq) {
    return noise(vec3(freq * uv.xy, 1))*0.5 +0.5;
}
float hash(vec2 p) // Dave H
{
vec3 p3  = fract(vec3(p.xyx) * .1031);
    p3 += dot(p3, p3.yzx + 33.33);
    return fract((p3.x + p3.y) * p3.z);
}
float paper1 (vec2 U) {
    float h = .005*(sin(.6*U.x+.1*U.y)+sin(.7*U.y-.1*U.x));
    for (float x = -1.; x<=1.;x++)
    for (float y = -1.; y<=1.;y++){
        h += .15*.125*hash(U+vec2(x,y));
    }
    return h;
}

  uniform shader uImage;
  uniform shader bgImage;
uniform shader paper;
uniform float r;
uniform float g;
uniform float b;
uniform float a;
uniform float w;
uniform float h;
uniform float ff;
uniform float top;
uniform float bot;
uniform float brush;
uniform float leng;
uniform int tms;
uniform float size;

vec4 main(vec2 pos) {
vec4 bg = bgImage.eval(pos);
vec4 sum = uImage.eval(pos);


return sum;

}
  `,
  shdSFlo:`

               vec3 hash( vec3 p ) // replace this by something better
{
p = vec3( dot(p,vec3(127.1,311.7, 74.7)),
dot(p,vec3(269.5,183.3,246.1)),
dot(p,vec3(113.5,271.9,124.6)));
return -1.0 + 2.0*fract(sin(p)*43758.5453123);
}
float noise(vec3 p )
{
    vec3 i = floor( p );
    vec3 f = fract( p );
vec3 u = f*f*(3.0-2.0*f);
 return mix( mix( mix( dot( hash( i + vec3(0.0,0.0,0.0) ),
                           f - vec3(0.0,0.0,0.0) ),
  dot( hash( i + vec3(1.0,0.0,0.0) ), f - vec3(1.0,0.0,0.0) ), u.x),
  mix( dot( hash( i + vec3(0.0,1.0,0.0) ), f - vec3(0.0,1.0,0.0) ),
 dot( hash( i + vec3(1.0,1.0,0.0) ),
     f - vec3(1.0,1.0,0.0) ), u.x), u.y),
 mix( mix( dot( hash( i + vec3(0.0,0.0,1.0) ), f - vec3(0.0,0.0,1.0) ),
 dot( hash( i + vec3(1.0,0.0,1.0) ), f - vec3(1.0,0.0,1.0) ), u.x),
mix( dot( hash( i + vec3(0.0,1.0,1.0) ), f - vec3(0.0,1.0,1.0) ),
dot( hash( i + vec3(1.0,1.0,1.0) ),
    f - vec3(1.0,1.0,1.0) ), u.x), u.y), u.z );
}
float simpleNoise(vec2 uv,float freq) {
    return noise(vec3(freq * uv.xy, 1))*0.5 +0.5;
}
float hash(vec2 p) // Dave H
{
vec3 p3  = fract(vec3(p.xyx) * .1031);
    p3 += dot(p3, p3.yzx + 33.33);
    return fract((p3.x + p3.y) * p3.z);
}
float paper1 (vec2 U) {
    float h = .005*(sin(.6*U.x+.1*U.y)+sin(.7*U.y-.1*U.x));
    for (float x = -1.; x<=1.;x++)
    for (float y = -1.; y<=1.;y++){
        h += .15*.125*hash(U+vec2(x,y));
    }
    return h;
}

  uniform shader uImage;
  uniform shader bgImage;
uniform shader paper;
uniform float r;
uniform float g;
uniform float b;
uniform float a;
uniform float w;
uniform float h;
uniform float ff;
uniform float top;
uniform float bot;
uniform float brush;
uniform float leng;
uniform int tms;
uniform float size;
vec4 main(vec2 pos) {
vec4 bg = bgImage.eval(pos);
float hCoef =  sin(1-(pos.y-top)/(bot-top))*2;
//hCoef =  1;
vec2 uv = pos / vec2(w,h);
vec4 sum0 = vec4(0.0);
vec4 sum3 = vec4(0.0);
float liu=1000000.0;
float wi=min(size*2,(size*(1+float(tms)/30)/10)); // + simpleNoise(uv,.04)*30;
float sel=0.0;
float lenn=0.0;
vec4 ln=uImage.eval(pos);
for (float i = 1; i <400.0; i++) {

if(i<leng-1){
sum0 = uImage.eval(vec2(i,1));
sum3 = uImage.eval(vec2(i+1,1));
vec2 p0=vec2(sum0.r*w,sum0.g*h);
vec2 p1=vec2(sum3.r*w,sum3.g*h);
vec2 v0 =pos -p0;
vec2 v1 =pos -p1;
vec2 l= p1 - p0;
vec2 ln=l / length(l);
vec2 v0l= v0 / length(v0);
float cos=dot(ln,v0l);

float sin=sqrt(1-cos*cos);
float lan =cos>0 && cos*length(v0)<=length(l) ? sin*length(v0) : 10000000.0;
if(lan<=liu ) sel= (cos*length(v0)<=length(l)) ? lenn+cos*length(v0) : length(v1)>length(v0) ?  lenn : lenn+length(l);
liu=min(liu,min(lan,min(length(v0),length(v1))));

lenn+=length(l);
}
}
sel=sel/lenn;

//float no = simpleNoise(vec2(0,sel),0.004)*100;
//wi=wi+sel*30;
liu=pow((min(wi,liu))/wi,2);
//liu=liu<.3 ? 0 : pow(liu-0.3,1);
 float smallNoise = simpleNoise(uv+vec2(ff,-ff), 100.0);
   liu += 0.05 * smallNoise;

    // slightly deforming the shapes with low-frequency noise make them look less synthetic
    float largeNoiseFreq = 1.5;
    float largeNoise = simpleNoise(uv+vec2(ff,-ff), largeNoiseFreq);
    liu -= 0.9 * smoothstep(0.35, 1.0, largeNoise);
//////
   float wetNoiseFreq = 3.3 + sin(ff); // 1.0 .. 3.0
    float wetNoiseStrength = 0.2; // 0.1 .. 0.2
    float wetNoise = simpleNoise(uv, wetNoiseFreq);
    float wetNoiseStep = smoothstep(0.4, 0.55 + wetNoiseStrength, wetNoise);
    float wetness = clamp(wetNoiseStep + (1-(bg.r+bg.b+bg.g)/3)*5, 0.0, 1.0);

////
   // strengthen the contrast at the edge (of the dry parts)
    float value;
    float valueSlim;
    if (liu < 0.02) {
        // no change in the center circle
        value = liu;
        valueSlim = 0.96;
    } else {
        const float aaDelta = 0.016; // add a small delta to reduce aliasing
        const float edgeWet = 0.84;
        float edgeDry = 0.04+0.04*hCoef;
        float edge1 = mix(edgeDry, edgeWet, wetness) + aaDelta;
        value =     smoothstep(edgeDry, edge1, liu);
        valueSlim = pow(1.0 - smoothstep(0.0, edge1, liu), 0.15);
    }
//liu=value;
 value = value + 0.5 * valueSlim;

    // add some more noise to give it a less uniform look
  float postNoise = simpleNoise(uv, 15.0);
    float ssStrength = 1.0;
    float postNoiseAmount = 1.0 - wetNoise;
    value = value + value *  postNoiseAmount * smoothstep(0.0, postNoise * ssStrength, value);
vec4 pap = paper.eval((pos+vec2(ff,1-ff))*2);
float papr=paper1(pos);
//////
//papr=pap.r;
  float noiseCol = noise(vec3(2.0 * uv.x, 2.0 * uv.y, 0.02));
    float gradient = 0.5 * (uv.x + uv.y);
    vec3 distCol = mix(vec3(r*1.0,g*1.0,b*1.0), vec3(abs(noiseCol)), vec3(r*1,g*1,b*1));
 distCol=vec3(r,g,b)- vec3(abs(noiseCol))*max(0,1-hCoef);//;
    vec3 colors = mix(distCol, vec3(1.0,1.0,1.0), value*1.2 - papr * 0.2);
vec3 bgrgb=bg.r+bg.b+bg.g>0 && bg.r+bg.b+bg.g!=3 && colors.r+colors.b+colors.g>0 ? bg.rgb : vec3(1);
//return vec4(bg.rgb,1);
return vec4(clamp(colors,0,1)*bg.rgb,1);
//return ln;
}
  `,
  shdSH:`
  uniform shader uImage;
  uniform shader uImage1;
uniform shader paper;
uniform float r;
uniform float g;
uniform float b;
uniform float a;
uniform float w;
uniform float h;
uniform float ff;
uniform float top;
uniform float bot;
uniform float brush;
vec4 main(vec2 pos) {
vec4 sum = uImage.eval(pos);
vec4 sum1 = uImage1.eval(pos);
float lineMask = sum.a; 
 float strokeOpacity = lineMask * .2;
 vec4 coloredStroke = vec4(r,g,b, 1.0);

return mix(sum1, coloredStroke, strokeOpacity);
}
  `,
shdS:`
  uniform shader uImage;
  uniform shader uImage1;
uniform shader paper;
uniform float r;
uniform float g;
uniform float b;
uniform float a;
uniform float w;
uniform float h;
uniform float ff;
uniform float top;
uniform float bot;
uniform float brush;
vec4 main(vec2 pos) {
float hCoef = (brush == 3 && (r+b+g<2.8)) ? sin(1-(pos.y-top)/(bot-top))*2 : 1;
vec2 uv = pos / vec2(w,h) + vec2(ff,0);
vec4 sum = vec4(0.0);
float h = 1.2;
sum+=uImage.eval( vec2( pos.x-2*h, pos.y-2*h ) ) * 0.05719095841793657;
sum+=uImage.eval( vec2( pos.x-h, pos.y-2*h ) ) * 0.25464400750007005;
sum+=uImage.eval( vec2( pos.x, pos.y-2*h ) ) * 0.3333333333333333;
sum+=uImage.eval( vec2( pos.x+h, pos.y-2*h ) ) * 0.25464400750007005;
sum+=uImage.eval( vec2( pos.x+2*h, pos.y-2*h ) ) * 0.05719095841793657;
sum+=uImage.eval( vec2( pos.x-2*h, pos.y-h ) ) * 0.25464400750007005;
sum+=uImage.eval( vec2( pos.x-h, pos.y-h ) ) * 0.5285954792089683;
sum+=uImage.eval( vec2( pos.x, pos.y-h ) ) * 0.6666666666666666;
sum+=uImage.eval( vec2( pos.x+h, pos.y-h ) ) * 0.5285954792089683;
sum+=uImage.eval( vec2( pos.x+2*h, pos.y-h ) ) * 0.25464400750007005;
sum+=uImage.eval( vec2( pos.x-2*h, pos.y ) ) * 0.3333333333333333;
sum+=uImage.eval( vec2( pos.x-h, pos.y ) ) * 0.6666666666666666;
sum+=uImage.eval( vec2( pos.x, pos.y ) );
sum+=uImage.eval( vec2( pos.x+h, pos.y ) ) * 0.6666666666666666;
sum+=uImage.eval( vec2( pos.x+2*h, pos.y ) ) * 0.3333333333333333;
sum+=uImage.eval( vec2( pos.x-2*h, pos.y+h ) ) * 0.25464400750007005;
sum+=uImage.eval( vec2( pos.x-h, pos.y+h ) ) * 0.5285954792089683;
sum+=uImage.eval( vec2( pos.x, pos.y+h ) ) * 0.6666666666666666;
sum+=uImage.eval( vec2( pos.x+h, pos.y+h ) ) * 0.5285954792089683;
sum+=uImage.eval( vec2( pos.x+2*h, pos.y+h ) ) * 0.25464400750007005;
sum+=uImage.eval( vec2( pos.x-2*h, pos.y+2*h ) ) * 0.05719095841793657;
sum+=uImage.eval( vec2( pos.x-h, pos.y+2*h ) ) * 0.25464400750007005;
sum+=uImage.eval( vec2( pos.x, pos.y+2*h ) ) * 0.3333333333333333;
sum+=uImage.eval( vec2( pos.x+h, pos.y+2*h ) ) * 0.25464400750007005;
sum+=uImage.eval( vec2( pos.x+2*h, pos.y+2*h ) ) * 0.05719095841793657;
sum*=.2;
sum = uImage.eval(pos);
vec4 pap = paper.eval((pos+vec2(ff,1-ff))*2);
float p=1-smoothstep(.5,.6,pap.r)/3;
vec4 sum1 = uImage1.eval(pos);
float alpha = r+g+b>2.9 ? sum.a : sum.a*a*p;

vec3 bgrgb = sum1.a==0 ? vec3(1) : sum1.rgb;
vec3 blendedRGB = r+g+b==2.9 ? (bgrgb * vec3(r,g,b)) : mix(bgrgb, vec3(r,g,b), min(.9999,alpha/hCoef));

float blendedAlpha = sum1.a + alpha * (1.0 - sum1.a);
return vec4(blendedRGB,blendedAlpha);

////// multiply blend
///half3 blendedRGB = bgColor.rgb * fgColor.rgb;
//p=1;

//float s=1-sum.a*a*p;
//return vec4(vec3(vec3(r,g,b)*sum.a*a*p + sum1.rgb*s),sum.a*a*p+sum1.a);
//return vec4(vec3(smoothstep(.5,.6,pap.r)),1);
}
  `,
  shdWet:`
               vec3 hash( vec3 p ) // replace this by something better
{
p = vec3( dot(p,vec3(127.1,311.7, 74.7)),
dot(p,vec3(269.5,183.3,246.1)),
dot(p,vec3(113.5,271.9,124.6)));
return -1.0 + 2.0*fract(sin(p)*43758.5453123);
}
float noise(vec3 p )
{
    vec3 i = floor( p );
    vec3 f = fract( p );
vec3 u = f*f*(3.0-2.0*f);
 return mix( mix( mix( dot( hash( i + vec3(0.0,0.0,0.0) ),
                           f - vec3(0.0,0.0,0.0) ),
  dot( hash( i + vec3(1.0,0.0,0.0) ), f - vec3(1.0,0.0,0.0) ), u.x),
  mix( dot( hash( i + vec3(0.0,1.0,0.0) ), f - vec3(0.0,1.0,0.0) ),
 dot( hash( i + vec3(1.0,1.0,0.0) ),
     f - vec3(1.0,1.0,0.0) ), u.x), u.y),
 mix( mix( dot( hash( i + vec3(0.0,0.0,1.0) ), f - vec3(0.0,0.0,1.0) ),
 dot( hash( i + vec3(1.0,0.0,1.0) ), f - vec3(1.0,0.0,1.0) ), u.x),
mix( dot( hash( i + vec3(0.0,1.0,1.0) ), f - vec3(0.0,1.0,1.0) ),
dot( hash( i + vec3(1.0,1.0,1.0) ),
    f - vec3(1.0,1.0,1.0) ), u.x), u.y), u.z );
}
float simpleNoise(vec2 uv,float freq) {
    return noise(vec3(freq * uv.xy, 1))*0.5 +0.5;
}
float hash(vec2 p) // Dave H
{
vec3 p3  = fract(vec3(p.xyx) * .1031);
    p3 += dot(p3, p3.yzx + 33.33);
    return fract((p3.x + p3.y) * p3.z);
}





  uniform shader uImage;
   uniform shader uLine;
uniform float r1;
uniform float r2;
uniform float wi;
uniform float hi;

vec4 main(vec2 pos) {
vec2 uv = pos / vec2(wi,hi) + vec2(r1,r2);
vec4 sum = uImage.eval( vec2( pos.x, pos.y ));
vec4 sum1= uLine.eval( vec2( pos.x, pos.y ));
float no=simpleNoise(uv,10.1);
float no1=simpleNoise(uv,2.7);
return vec4(sum.rgb,1);
//return vec4(vec3(smoothstep(0.1,0.3,1-sum.a-sum.a-no)),1);
}`
,
  shdFinal:`
    uniform shader uImage;
  uniform shader uImage1;

uniform float wi;
uniform float hi;
uniform float ff;
vec4 main(vec2 pos) {
  vec4 sum = uImage1.eval( pos);
 return sum;
}`,
  shdFinal_:`
               vec3 hash( vec3 p ) // replace this by something better
{
p = vec3( dot(p,vec3(127.1,311.7, 74.7)),
dot(p,vec3(269.5,183.3,246.1)),
dot(p,vec3(113.5,271.9,124.6)));
return -1.0 + 2.0*fract(sin(p)*43758.5453123);
}
float noise(vec3 p )
{
    vec3 i = floor( p );
    vec3 f = fract( p );
vec3 u = f*f*(3.0-2.0*f);
 return mix( mix( mix( dot( hash( i + vec3(0.0,0.0,0.0) ),
                           f - vec3(0.0,0.0,0.0) ),
  dot( hash( i + vec3(1.0,0.0,0.0) ), f - vec3(1.0,0.0,0.0) ), u.x),
  mix( dot( hash( i + vec3(0.0,1.0,0.0) ), f - vec3(0.0,1.0,0.0) ),
 dot( hash( i + vec3(1.0,1.0,0.0) ),
     f - vec3(1.0,1.0,0.0) ), u.x), u.y),
 mix( mix( dot( hash( i + vec3(0.0,0.0,1.0) ), f - vec3(0.0,0.0,1.0) ),
 dot( hash( i + vec3(1.0,0.0,1.0) ), f - vec3(1.0,0.0,1.0) ), u.x),
mix( dot( hash( i + vec3(0.0,1.0,1.0) ), f - vec3(0.0,1.0,1.0) ),
dot( hash( i + vec3(1.0,1.0,1.0) ),
    f - vec3(1.0,1.0,1.0) ), u.x), u.y), u.z );
}
float simpleNoise(vec2 uv,float freq) {
    return noise(vec3(freq * uv.xy, 1))*0.5 +0.5;
}
float hash(vec2 p) // Dave H
{
vec3 p3  = fract(vec3(p.xyx) * .1031);
    p3 += dot(p3, p3.yzx + 33.33);
    return fract((p3.x + p3.y) * p3.z);
}
  uniform shader uImage;
  uniform shader uImage1;

uniform float wi;
uniform float hi;
uniform float ff;
vec4 main(vec2 pos) {
vec2 uv = pos / vec2(wi,hi) + vec2(ff,0);
vec4 sum = uImage.eval( vec2( pos.x, pos.y ));
vec4 pap = uImage1.eval(pos*2);
float no=simpleNoise(uv,227);
float no1=simpleNoise(uv,1.7);
float cy=pos.y/hi;
vec3 light=normalize(vec3(0.2+uv.x, uv.y/2, -0.01));
float dot=(dot(normalize(pap.rgb),light)+1)/3.7;
vec3 bgCol=mix(vec3(250,250,243)/255,vec3(255-100*cy,255-100*cy,255-110*cy)/255,dot);
//bgCol=vec3(.98,.98,.98);
vec3 blendedRGB = mix(bgCol, sum.rgb, sum.a*pow(dot,2)*0.6);
blendedRGB = sum.r+sum.g + sum.b == 3 ? blendedRGB : sum.r+sum.g + sum.b +sum.a== 0 ? bgCol :  bgCol*sum.rgb;
//float blendedAlpha = sum1.a + alpha * (1.0 - sum1.a);

return vec4(blendedRGB,1);
}`,
shdFinalN:`
               vec3 hash( vec3 p ) // replace this by something better
{
p = vec3( dot(p,vec3(127.1,311.7, 74.7)),
dot(p,vec3(269.5,183.3,246.1)),
dot(p,vec3(113.5,271.9,124.6)));
return -1.0 + 2.0*fract(sin(p)*43758.5453123);
}
float noise(vec3 p )
{
    vec3 i = floor( p );
    vec3 f = fract( p );
vec3 u = f*f*(3.0-2.0*f);
 return mix( mix( mix( dot( hash( i + vec3(0.0,0.0,0.0) ),
                           f - vec3(0.0,0.0,0.0) ),
  dot( hash( i + vec3(1.0,0.0,0.0) ), f - vec3(1.0,0.0,0.0) ), u.x),
  mix( dot( hash( i + vec3(0.0,1.0,0.0) ), f - vec3(0.0,1.0,0.0) ),
 dot( hash( i + vec3(1.0,1.0,0.0) ),
     f - vec3(1.0,1.0,0.0) ), u.x), u.y),
 mix( mix( dot( hash( i + vec3(0.0,0.0,1.0) ), f - vec3(0.0,0.0,1.0) ),
 dot( hash( i + vec3(1.0,0.0,1.0) ), f - vec3(1.0,0.0,1.0) ), u.x),
mix( dot( hash( i + vec3(0.0,1.0,1.0) ), f - vec3(0.0,1.0,1.0) ),
dot( hash( i + vec3(1.0,1.0,1.0) ),
    f - vec3(1.0,1.0,1.0) ), u.x), u.y), u.z );
}
float simpleNoise(vec2 uv,float freq) {
    return noise(vec3(freq * uv.xy, 1))*0.5 +0.5;
}
float hash(vec2 p) // Dave H
{
vec3 p3  = fract(vec3(p.xyx) * .1031);
    p3 += dot(p3, p3.yzx + 33.33);
    return fract((p3.x + p3.y) * p3.z);
}
  uniform shader uImage;
  uniform shader uImage1;
  uniform shader uLine;

uniform float wi;
uniform float hi;
uniform float ff;
vec4 main(vec2 pos) {
vec2 uv = pos / vec2(wi,hi) + vec2(ff,0);
vec4 sum = uImage.eval( vec2( pos.x, pos.y ));
vec4 pap = uImage1.eval(pos*2);
float no=simpleNoise(uv,227);
float no1=simpleNoise(uv,1.7);
float cy=pos.y/hi;
vec3 light=normalize(vec3(0.2+uv.x, uv.y/4, -0.01));
float dot=(dot(normalize(pap.rgb),light)+1)/2;
vec3 bgCol=mix(vec3(235,235,215)/255,vec3(255-160*cy,255-160*cy,255-180*cy)/255,dot);
//bgCol=vec3(.98,.98,.98);
vec3 blendedRGB = mix(bgCol, sum.rgb, sum.a*pow(dot,2)*0.6);
blendedRGB = sum.r+sum.g + sum.b == 3 ? blendedRGB : sum.r+sum.g + sum.b +sum.a== 0 ? bgCol :  bgCol*sum.rgb;
//float blendedAlpha = sum1.a + alpha * (1.0 - sum1.a);

return vec4(blendedRGB,1);
}`
}
}

